import { render, staticRenderFns } from "./subApproval.vue?vue&type=template&id=6b1fd911&scoped=true&"
import script from "./subApproval.vue?vue&type=script&lang=js&"
export * from "./subApproval.vue?vue&type=script&lang=js&"
import style0 from "./subApproval.vue?vue&type=style&index=0&id=6b1fd911&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1fd911",
  null
  
)

export default component.exports